import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useMutation, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import './DanhMucPhanMemShow.scss';
import { DANHMUCPHANMEM_API, BaseGatewayImage, BaseGatewayAuthImage, ACCOUNT_API } from '@app/utils/apiUrl';
import { Get, Post } from '@app/utils/httpProvider';
import { createUrlWithParam } from '@app/utils/helper';
import { URI_INTERNAL } from '@app/utils/pathLocations';
import { apiRoleMappingPagingAction } from '@app/store/reducers/apiRoleMapping';
import { userManager } from '@app/utils/oidc';

const DanhMucPhanMemShow = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);
    const itemAccountAuthInfo = useSelector((state) => state.account?.itemAccountAuthInfo);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');
    const [showAccessModal, setShowAccessModal] = useState(false);

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (paramUrl.get('page') != null && parseInt(paramUrl.get('page'), 10) !== page) {
        setPage(parseInt(paramUrl.get('page'), 10));
    }
    if (paramUrl.get('size') != null && parseInt(paramUrl.get('size'), 10) !== pageSize) {
        setPageSize(parseInt(paramUrl.get('size'), 10));
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }

    const replaceHistory = (Page, Size, Search) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.DANHMUCPHANMEM_SHOW_PATH, {
                page: Page,
                size: Size,
                search: Search
            })
        );
    };

    const { isLoading, isError, error, data, refetch } = useQuery(
        ['danhMucPhanMemShowData', valueSearch, page, pageSize],
        () => {
            const model = {
                Keyword: valueSearch || '',
                PageIndex: page,
                PageSize: pageSize
            };
            replaceHistory(page, pageSize, valueSearch);
            return Get(DANHMUCPHANMEM_API.GET_PAGING_SHOW, null, model);
        },
        {
            keepPreviousData: true
        }
    );

    useEffect(() => {
        refetch();
    }, [pageSize, page]);

    useEffect(() => {
        if (valueSearch != null && valueSearch !== search) {
            setPage(1);
            replaceHistory(1, pageSize, valueSearch);
        }
    }, [valueSearch]);

    const items = data?.data?.$values ? data.data.$values : data?.data || [];
    const fullName = [
        itemAccountAuthInfo?.lastName,
        itemAccountAuthInfo?.middleName,
        itemAccountAuthInfo?.firstName
    ].filter(Boolean).join(' ') || itemAccountAuthInfo?.userName || itemAccountAuthInfo?.email || 'Nguyen Van A';

    const resolveImageUrl = (path, baseUrl = BaseGatewayImage) => {
        if (!path) return '';
        if (path.startsWith('http://') || path.startsWith('https://')) return path;
        return `${baseUrl}/${path.replace(/^\//, '')}`;
    };

    const avatarUrl = itemAccountAuthInfo?.imageThumbnail
        ? resolveImageUrl(itemAccountAuthInfo.imageThumbnail, BaseGatewayAuthImage)
        : '/img/default-profile.png';

    const getItemValue = (item, keys, fallback = '') => {
        const foundKey = keys.find((key) => item?.[key] !== undefined && item?.[key] !== null && item?.[key] !== '');
        return foundKey ? item[foundKey] : fallback;
    };

    const stripHtml = (value) => {
        if (!value) return '';
        return String(value).replace(/<[^>]*>/g, '').trim();
    };

    const getArrayValue = (value) => {
        if (Array.isArray(value)) return value;
        if (Array.isArray(value?.$values)) return value.$values;
        return [];
    };

    const getAllowedRoles = (item) =>
        getArrayValue(item?.lstAllowedRoles || item?.LstAllowedRoles)
            .map((role) => ({
                id: role.id || role.Id || role.value || role.Value,
                name: role.name || role.Name || role.label || role.Label
            }))
            .filter((role) => role.id);

    const addRoleFunc = useMutation((value) =>
        Post(ACCOUNT_API.ADD_ROLE_TO_ACCOUNT, null, value, false)
    );

    const handleAccess = async (values) => {
        const model = {
            lstRoleOfPhanMem: getAllowedRoles(values)
        };

        try {
            const res = await addRoleFunc.mutateAsync(model);

            if (res.status !== 200) {
                toast.error('Khong the cap quyen truy cap, vui long thu lai.');
                return;
            }

            await userManager.signinSilent();
            // await dispatch(
            //     apiRoleMappingPagingAction({ PageIndex: 1, PageSize: 10000 })
            // ).unwrap();
            const hasPendingUserRole = model.lstRoleOfPhanMem.some((role) =>
                role.name?.startsWith('PENDINGUSER')
            );
            if (hasPendingUserRole) {
                setShowAccessModal(true);
            } else {
                toast.success('Bạn đã có quyền truy cập phần mềm...');
            }
        } catch (res) {
            toast.error(
                res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
            );
        }
    };

    return (
        <div className="software-home">
            <Modal
                show={showAccessModal}
                onHide={() => setShowAccessModal(false)}
                centered
                backdrop="static"
                contentClassName="software-access-modal"
                aria-labelledby="software-access-modal-title"
                aria-describedby="software-access-modal-description"
            >
                <Modal.Header closeButton closeLabel="Đóng thông báo">
                    <span className="software-access-modal__eyebrow">QUYỀN TRUY CẬP PHẦN MỀM</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="software-access-modal__icon" aria-hidden="true">
                        <i className="fas fa-user-lock" />
                    </div>
                    <Modal.Title as="h2" id="software-access-modal-title">
                        Liên hệ để được cấp quyền
                    </Modal.Title>
                    <p id="software-access-modal-description" className="software-access-modal__description">
                        Bạn cần liên hệ <strong>phòng Huấn luyện đào tạo</strong> để được cấp quyền truy cập phần mềm.
                    </p>
                    <div className="software-access-modal__contact">
                        <i className="fas fa-phone-alt" aria-hidden="true" />
                        <div>
                            <strong>Phòng Huấn luyện đào tạo</strong>
                            <span>Số điện thoại: 024.6278.4179</span>
                        </div>
                    </div>
                    <button
                        type="button"
                        className="software-access-modal__button"
                        onClick={() => setShowAccessModal(false)}
                    >
                        Đã hiểu
                    </button>
                </Modal.Body>
            </Modal>
            <div className="software-home__top">
                <div className="software-home__welcome">
                    <img className="software-home__avatar" src={avatarUrl} alt="User" />
                    <div>
                        <h1 className="software-home__hello">
                            Xin chào, <span>{fullName}</span>
                        </h1>
                        <p className="software-home__subtitle">
                            Chào mừng bạn đến với Hệ thống quản lý huấn luyện đào tạo
                        </p>
                    </div>
                </div>

                <div className="software-home__notice">
                    <div className="software-home__notice-title">
                        <i className="far fa-bell" />
                        Thông báo
                    </div>
                    <p className="software-home__notice-text">
                        Hồ sơ đăng ký của bạn đang ở trạng thái <strong>Chờ thẩm định</strong>
                    </p>
                </div>
            </div>

            <h2 className="software-home__section-title">Tôi muốn đăng ký / thực hiện</h2>

            {isLoading ? (
                <div className="software-home__status">Đang tải danh sách phần mềm...</div>
            ) : isError ? (
                <div className="software-home__status">Lỗi: {error?.message || 'Không tải được dữ liệu'}</div>
            ) : items.length === 0 ? (
                <div className="software-home__status">Không có dữ liệu</div>
            ) : (
                <div className="software-home__grid">
                    {items.map((item, index) => {
                        const name = getItemValue(item, ['tenPhanMem', 'TenPhanMem'], 'Chưa cập nhật');
                        const description = stripHtml(getItemValue(item, ['moTa', 'MoTa'], ''));
                        const imagePath = getItemValue(item, ['imagePath', 'ImagePath']);

                        return (
                            <div className="software-card" key={item.id || item.Id || index}>
                                <div className="software-card__image-wrap">
                                    {imagePath ? (
                                        <img
                                            className="software-card__image"
                                            src={resolveImageUrl(imagePath)}
                                            alt={name}
                                        />
                                    ) : (
                                        <i className="software-card__fallback fas fa-th-large" />
                                    )}
                                </div>

                                <h3 className="software-card__title">
                                    {index + 1}. {name}
                                </h3>
                                <p className="software-card__desc">{description || 'Chức năng đang được cập nhật'}</p>

                                <button
                                    type="button"
                                    className="software-card__button"
                                    onClick={() => handleAccess(item)}
                                >
                                    Truy cập
                                    <i className="fas fa-arrow-right" />
                                </button>
                            </div>
                        );
                    })}
                </div>
            )}

            <div className="software-home__note">
                <i className="fas fa-info-circle" />
                Lưu ý: Các chức năng hiển thị dựa trên vai trò và quyền của bạn trong hệ thống.
            </div>
        </div>
    );
};

export default DanhMucPhanMemShow;
